export const WeekDay = [ 'Sun' ,'Mon', 'Tue', 'Wed', 'Thu', 'Fri' , 'Sat']
export const PersianMonth = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
]